import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import HeaderSection from "../components/shared/HeaderSection";

const Careers = () => {
  const jobOpenings = [
    {
      title: "Software Engineer Intern",
      description:
        "We are looking for a passionate Software Engineer Intern to assist in designing, developing, and maintaining software solutions. Join our team to gain hands-on experience working on cutting-edge projects with modern technologies. 🚀",
      link: "/careers/software-engineer",
    },
    {
      title: "UI/UX Designer Intern",
      description:
        "Are you a creative UI/UX Designer? Help us craft intuitive and visually appealing user experiences for our clients.",
      link: "/careers/ui-ux-designer",
    },
    {
        title: "Mobile App Developer Intern",
        description:
          "Join our team as a Mobile App Developer Intern and gain hands-on experience in building innovative mobile applications. Work alongside experienced developers and learn the latest technologies.",
        link: "/careers/mobile-app-developer-interns",
    },
  ];

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Header Section */}
      <HeaderSection
        image="/images/bg-images/careers-bg.jpg"
        header="Careers"
        subHeader="Join Our Team & Be a Part of Innovation!"
      />

      {/* Main Content */}
      <div className="bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white p-8 md:p-8 lg:p-16 shadow-lg">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left Content */}
          <div>
            <h1 className="text-2xl sm:text-4xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">
            Careers at Hither Tech
            </h1>
            <p className="text-gray-300 mb-4">
              At Hither Tech, we are always looking for talented professionals
              to join our growing team. If you're passionate about technology
              and innovation, explore our current job openings and apply today!
            </p>
            <p className="text-gray-300">
              For career inquiries, send your resume to{" "}
              <a
                href="mailto:careers@hithertech.co.uk"
                className="text-blue-400 hover:underline"
              >
                careers@hithertech.co.uk
              </a>
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <motion.img
              src="/images/careers-image.jpg"
              alt="Careers at Hither Tech"
              className="w-full max-w-md rounded-lg shadow-lg"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            />
          </div>
        </div>

        {/* Job Openings Section */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold mb-6 text-center">
            Current Job Openings
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {jobOpenings.map((job, index) => (
              <div
                key={index}
                className="bg-gray-700 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <h4 className="text-xl font-semibold mb-4 text-white">
                  {job.title}
                </h4>
                <p className="text-gray-300 mb-4">{job.description}</p>
                <Link
                  to={job.link}
                  className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-300"
                >
                  Learn More
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default Careers;